module.exports = __webpack_public_path__ + "app/components/label-value-3I1GzBq2.html";